<template>
  <div class="right-panel">
    <div class="reader box" :style="{ width: isText ? '834px' : '1480px' }">
      <div class="part-title">
        &diams;<span class="inline-title">原版阅读</span>
        <div class="top-tools" :style="{ marginLeft: isText ? '590px' : '1180px' }">
          <el-tooltip class="item" effect="dark" content="背景设置" placement="top-start">
            <el-popover placement="bottom" width="100" trigger="click">
              <div style="display: flex; align-items: center">
                <el-color-picker :predefine="predefineColors" color-format="hex" v-model="bgPick" size="mini" @change="changeBg"></el-color-picker>
                <div style="margin-left: 12px">{{ bgPick }}</div>
              </div>
              <div slot="reference" class="tool bgs"></div>
            </el-popover>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="下载" placement="top-start">
            <div class="tool download" @click="downloadPdf" v-show="library.pdfDownloadPermission"></div>
          </el-tooltip>
        </div>
      </div>
      <div class="reader-content" :style="{ backgroundColor: bgPick }" @mouseenter="enter" @mouseleave="leave">
        <div class="left-content">
          <turn-book ref="turnBook" :pages="pages" :curPage="curPage" :zoom="zoom" />
          <div class="water-mark" :style="{ backgroundImage: `url(${waterMark})` }">
            <i class="el-icon-back btn" @click="changePage('previous')"></i>
            <i class="el-icon-right btn" @click="changePage('next')"></i>
          </div>
        </div>
      </div>
      <div class="bottom-tools">
        <div class="zoom">
          <div class="icon minus" @click="zoomTo(-10)"></div>
          {{ zoom + "%" }}
          <div class="icon plus" style="margin-left: 16px" @click="zoomTo(10)"></div>
        </div>
        <div class="icon fullscreen" @click="fullReader"></div>
        <div class="icon first-page" @click="changePage('first')"></div>
        <div class="icon pre" @click="changePage('previous')"></div>
        <div class="pager"><el-input v-model="curPage" @change="setPage" style="width: 70px"></el-input>&nbsp;/&nbsp;{{ total }}</div>
        <div class="icon next" @click="changePage('next')"></div>
        <div class="icon last-page" @click="changePage('last')"></div>
        <div class="switch" style="margin-left: 16px">
          <el-switch v-model="isText" style="margin-right: 12px" active-color="#FFA40F" inactive-color="#ddd"></el-switch>
          {{ isText ? "文本显示" : "文本隐藏" }}
        </div>
      </div>
    </div>
    <div class="text-content box oned" :style="{ backgroundColor: bgPick, width: isText ? '593px' : '0px', padding: isText ? '24px 19px' : '0px' }">
      <div class="text-area" id="text-area" v-html="readText"></div>
    </div>
  </div>
</template>
<script>
import turnBook from '@/components/turn-book'
import FullScreen from '@/utils/fullscreen'
import { getSearchParams } from '@/utils'
import { mapGetters } from 'vuex'
import Custom from '@/api/custom'
let apiWaterMark = new Custom('watermark')
const reader = new FileReader()
function getFileFromUrl (url) {
  return new Promise(async (resolve, reject) => {
    let fileBits = []
    if (url instanceof Array) {
      for (let addres of url) {
        const response = await fetch(addres)
        const blob = await response.blob()
        fileBits.push(blob)
      }
    } else {
      const response = await fetch(url)
      const blob = await response.blob()
      fileBits = [blob]
    }
    let file = new File(fileBits, 'test', { type: fileBits[0].type })
    resolve(file)
  })
}
export default {
  data () {
    return {
      isText: true,
      zoom: 100,
      curPage: 1,
      total: 8,
      isSimplified: true,
      bgPick: '#fff',
      predefineColors: ['#FFFFFF', '#E3EDCD', '#f1e9d2'],
      fullFn: new FullScreen(),
      pages: [],
      readText: '',
      bookId: '',
      pageNum: 1,
      waterMark: '',
      volumeName: ''
    }
  },
  components: {
    turnBook
  },
  props: {
    book: Object
  },
  computed: {
    ...mapGetters(['isTra', 'library']),
    brCount () {
      return this.readText.split('<br/>').length - 1
    }
  },
  methods: {
    zoomTo (num) {
      this.zoom += num
      // this.$refs.turnBook.setParams('zoom', this.zoom / 100)
    },
    changePage (key) {
      switch (key) {
        case 'next':
          if (this.curPage >= this.total) return
          this.curPage += 1
          break
        case 'previous':
          if (this.curPage < 2) return
          this.curPage -= 1
          break
        case 'first':
          this.curPage = 1
          break
        case 'last':
          this.curPage = this.total
          break
      }
    },
    initPage () {
      // let bookFilePath = process.env.NODE_ENV === 'production' ? this.library.bookFilePath : 'http://localhost:8047/book'
      let bookFilePath = this.library.bookFilePath
      let prefix = `${bookFilePath}/pdf/${this.bookId}/${this.volumeName}`
      this.pages.push({
        url: `${prefix}/0001.pdf`
      })
      for (let i = 2; i < this.pageNum; i++) {
        if (this.library.docType === 'double') {
          this.pages.push({
            url: `${prefix}/` + String(i).padStart(4, '0') + '.pdf'
          })
        } else {
          this.pages.push({
            url: [`${prefix}/` + String(i).padStart(4, '0') + 'A.pdf', `${prefix}/` + String(i).padStart(4, '0') + 'B.pdf']
          })
        }
      }
      this.pages.push({
        url: `${prefix}/` + String(this.pageNum).padStart(4, '0') + '.pdf'
      })
      // this.pages = this.pages.reverse()
      this.total = this.pageNum / 2
      let page = getSearchParams(window.location.href).page.replace(/[^\d]/g, '')
      if (page) {
        this.$nextTick(() => {
          this.setPage(Number(page))
          this.getPage(Number(page))
        })
      } else {
        this.getPage(1)
      }
    },
    changeBg (key) {
      localStorage.setItem('readerBg', key)
      // let obj = this.readerThemes.find(item => item.key === key)
    },
    fullReader () {
      // this.$refs.turnBook.preview()
      this.fullFn.Full('.reader-content .left-content')
    },
    async getPage (_page) {
      if (_page === '' || this.library.txtShow === 0) return
      let url
      // let bookFilePath = process.env.NODE_ENV === 'production' ? this.library.bookFilePath : 'http://localhost:8047/book'
      let bookFilePath = this.library.bookFilePath
      let prefix = `${bookFilePath}/text/${this.bookId}/${this.volumeName}`
      const page = Number(_page)
      if (page === 1 || page === this.pageNum || this.library.docType === 'double') {
        url = `${prefix}/` + String(page).padStart(4, '0') + '.txt'
      } else {
        const separatorPage = window.location.origin + window.location.pathname + 'br.txt'
        url = [`${prefix}/` + String(page).padStart(4, '0') + 'B.txt', separatorPage, `${prefix}/` + String(page).padStart(4, '0') + 'A.txt']
      }
      let file = await getFileFromUrl(url)
      reader.readAsText(file, 'GB2312')
    },
    setPage (val) {
      this.curPage = Number(val)
    },
    enter () {
      document.getElementById('main-container-home').style.overflowY = 'hidden'
    },
    leave () {
      document.getElementById('main-container-home').style.overflowY = 'auto'
    },
    downloadPdf () {
      this.$bus.$emit('downloadPdf')
    }
  },
  mounted () {
    this.isText = Boolean(this.library.txtShow)
    if (localStorage.getItem('readerBg')) {
      this.bgPick = localStorage.getItem('readerBg')
    } else {
      localStorage.setItem('readerBg', this.bgPick)
    }
    let queryObj = getSearchParams(window.location.href)
    this.bookId = queryObj.bookId
    this.pageNum = Number(queryObj.fileNumber)
    this.volumeName = queryObj.volumeName === '' ? '0001' : queryObj.volumeName
    this.initPage()
    this.$bus.$on('setPage', page => {
      this.curPage = Number(page)
    })
    apiWaterMark.getRecords({
      pageIndex: 1,
      pageSize: 1
    }).then(res => {
      this.waterMark = res.rows[0].imageBase64Str
    })
    // 获取选中
    document.addEventListener('selectionchange', () => {
      if (window.getSelection().focusNode.parentNode.id === 'text-area') {
        let text = window.getSelection().toString()
        if (text.length > 0) {
          this.selectText = text
        }
      }
    })
    reader.onload = e => {
      this.readText = e.target.result
    }
  },
  watch: {
    curPage (page) {
      this.getPage(page)
    },
    isTra (val) {
      if (val) {
        this.readText = ''
        this.getPage(this.curPage)
      }
    }
  }
}
</script>
<style lang="less" scoped>
@import "~@/styles/variables.less";
.reader {
  width: 834px;
  height: 100%;
  padding: 13px 14px;
  transition: width 0.5s;
  .top-tools {
    width: 81px;
    display: flex;
    justify-content: space-between;
    margin-left: 430px;
    transition: margin-left 0.5s;
    .tool {
      width: 31px;
      height: 31px;
      background-size: 100% 100%;
      cursor: pointer;
    }
  }
  .reader-content {
    width: 100%;
    height: 86%;
    padding: 13px 14px;
    display: flex;
    .left-content {
      width: 100%;
      height: 100%;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      justify-content: center;
      overflow: hidden;
      transition: height 0.5s;
      .water-mark {
        width: 806px;
        position: fixed;
        height: 660px;
        background-size: auto 100%;
        background-repeat: no-repeat;
        background-position: center;
        pointer-events: none;
        z-index: 1;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 24px;
        .btn {
          pointer-events: all;
          cursor: pointer;
          .font-size-extra-big;
          display: none;
          color: rgba(255, 255, 255, 0.5);
          &:hover {
            color: rgba(255, 255, 255, 1);
          }
        }
      }
      &:not(:root):fullscreen {
        .water-mark {
          width: 100% !important;
          height: 100% !important;
          .btn {
            display: block;
          }
        }
      }
    }
    .right-content {
      height: 100%;
      width: 40%;
    }
  }
  .bottom-tools {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 16px;
    color: #7c1823;
    .icon {
      width: 38px;
      height: 38px;
      background-size: 100% 100%;
      cursor: pointer;
      margin-left: 24px;
    }
    .switch {
      .font-size-default;
    }
    .pager {
      margin-left: 32px;
      display: flex;
      align-items: center;
      color: #7a7374;
      .font-size-extra-big;
      /deep/ .el-input__inner {
        text-align: center;
        .font-size-extra-big;
        background: #f5f2eb;
      }
      /deep/ .el-input__icon {
        color: #7a7374;
      }
    }
    .inline-input {
      width: 400px;
      margin-left: 32px;
      /deep/ .el-input__inner {
        border-color: #7c1823;
      }
    }
  }
}
.text-content {
  font-family: FangZhengKaiTi-GBK;
  width: 593px;
  height: 100%;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  background-clip: content-box;
  transition: width 0.5s;
  .text-area {
    width: 100%;
    height: 100%;
    border-radius: 4px;
    .font-size-extra-big;
    // writing-mode: vertical-rl;
    // text-orientation: upright;
    overflow-y: auto;
    // text-indent: 2em;
  }
}
</style>
<style lang="less">
@import "~@/styles/variables.less";
.el-textarea__inner {
  border: 2px solid #f5f2eb;
  color: #7a7374;
  background-color: #f5f2eb;
}
.draw-ct-btn {
  width: 160px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: "FangZhengKaiTi-GBK";
  .font-size-medium;
  color: #7c1823;
  border: 2px solid #7c1823;
  border-radius: 4px;
  cursor: pointer;
  margin-right: 24px;
}
</style>
